import Naluri from '~/common/api/naluri';
import {
  COMMON_GET_CHANNEL_COUNT_BEGIN,
  COMMON_GET_CHANNEL_COUNT_SUCCESS,
  COMMON_GET_CHANNEL_COUNT_FAILURE,
  COMMON_GET_CHANNEL_COUNT_DISMISS_ERROR,
} from './constants';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getChannelCount(params) {
  return dispatch => {
    // optionally you can have getState as the second argument
    dispatch({
      type: COMMON_GET_CHANNEL_COUNT_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      const doRequest = Naluri.get(`/api/expert/channels/totals/outer_tabs`, params);
      doRequest.then(
        res => {
          dispatch({
            type: COMMON_GET_CHANNEL_COUNT_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        err => {
          dispatch({
            type: COMMON_GET_CHANNEL_COUNT_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetChannelCountError() {
  return {
    type: COMMON_GET_CHANNEL_COUNT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COMMON_GET_CHANNEL_COUNT_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getChannelCountPending: true,
        getChannelCountError: null,
      };

    case COMMON_GET_CHANNEL_COUNT_SUCCESS:
      // The request is success
      const channelOuterCount = action.data;

      return {
        ...state,
        outerTabsTotal: channelOuterCount,
        getChannelCountPending: false,
        getChannelCountError: null,
      };

    case COMMON_GET_CHANNEL_COUNT_FAILURE:
      // The request is failed
      return {
        ...state,
        getChannelCountPending: false,
        getChannelCountError: action.data.error,
      };

    case COMMON_GET_CHANNEL_COUNT_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getChannelCountError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/common/redux/getChannelCount.js